import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CommonController } from '@classes/common.controller';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { ModalService } from '@services/modal.service';
import { PcsDocumentAndApprovalServices } from '@services/pcs-document-and-approval-services.service';
import { AdditionalDataSaveModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/AdditionalDataSaveModel';
import { PcsDocumentAndApprovalAdditionalDataDisplayModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/DetailsDisplayModels/PcsDocumentAndApprovalAdditionalDataDisplayModel';
import { AdditionalDataInputComponent } from './additional-data-input/additional-data-input.component';

@Component({
    selector: 'app-pcs-approval-tab-additional-data',
    templateUrl: './pcs-approval-tab-additional-data.component.html',
    styleUrls: ['./pcs-approval-tab-additional-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PcsApprovalTabAdditionalDataComponent extends CommonController implements OnInit {
    constructor(
        protected dialogService: ModalService,
        protected translateService: TranslateService,
        private service: PcsDocumentAndApprovalServices
    ) {
        super(dialogService, translateService);
    }

    @Input()
    additionalData: PcsDocumentAndApprovalAdditionalDataDisplayModel[];

    @Input()
    isForApproval = false;

    @Input()
    allowedAdditionalData = false;

    skip = 0;

    pageSize = 10;

    gridView: GridDataResult;

    openedId = -1;

    formGroup: UntypedFormGroup;

    editedRowIndex: number;

    isCurrentlyEditing = false;

    disableEdit = true;

    @ViewChildren('additionalDataInputs')
    additionalDataInputs: AdditionalDataInputComponent[];

    ngOnInit(): void {
        this.loadItems();
    }

    public pageChange({ skip, take }: PageChangeEvent): void {
        this.skip = skip;
        this.pageSize = take;
        this.loadItems();
    }

    private loadItems(): void {
        this.gridView = {
            data: this.additionalData.slice(this.skip, this.skip + this.pageSize),
            total: this.additionalData.length
        };
    }

    public enableAdditionalDataEdit() {
        if (this.allowedAdditionalData) {
            this.disableEdit = !this.disableEdit;
        }
    }

    public cancelEdit() {
        this.additionalDataInputs.forEach((adi) => adi.resetToInitialData());
        this.disableEdit = !this.disableEdit;
    }

    public saveEdit() {
        const saveData: AdditionalDataSaveModel[] = [];
        this.additionalDataInputs.forEach((adi) => {
            const newData = adi.getValue();
            if (newData !== null) {
                if (newData.value === '' && adi.isMandatory()) {
                    return; // if data is mandatory don't allow save
                }
                saveData.push(newData);
            }
        });
        if (saveData.length > 0) {
            this.service
                .saveAdditionalData({
                    additionalData: saveData
                })
                .subscribe((response) => {
                    if (response === true) {
                        this.additionalDataInputs.forEach((adi) => adi.updateDefaultValue());
                        this.disableEdit = !this.disableEdit;
                    }
                });
        }
    }

    isAnyInputRequired(): boolean {
        const inputComponents: AdditionalDataInputComponent[] = Array.from(this.additionalDataInputs);
        return inputComponents.some((input) => input.isMandatory() && (input.value === null || input.value === ''));
    }

    public StringToOther(value: string, type: string) {
        if (type === 'NumericTextBox') {
            return Number(value);
        } else if (type === 'DateTime') {
            return new Date(value);
        } else if (type === 'Checkbox') {
            return value.toLowerCase() === 'true';
        }
        return value;
    }
}
